var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasketballratingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9991 24.6109L30.6325 20.9775C27.218 17.0098 25.3421 11.9476 25.3464 6.71289C25.3464 6.18555 25.3665 5.65293 25.4034 5.13086C20.7289 5.46026 16.2843 7.28432 12.7261 10.3336L26.9991 24.6109Z",
    fill: "#1B51BB",
    fillOpacity: 0.08
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0256 18.5845L41.2722 10.3336C37.7655 7.3278 33.3962 5.51108 28.7921 5.14457C28.7489 5.66137 28.7246 6.18449 28.7246 6.71289C28.7203 11.0523 30.2428 15.2548 33.0256 18.5845Z",
    fill: "#1B51BB",
    fillOpacity: 0.08
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4124 20.9712C38.7416 23.7551 42.9442 25.2788 47.2839 25.2754C47.8113 25.2754 48.3386 25.2511 48.8523 25.2079C48.4864 20.6027 46.6697 16.2322 43.6632 12.7246L35.4124 20.9712Z",
    fill: "#1B51BB",
    fillOpacity: 0.08
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5859 33.0242C15.2568 30.2401 11.0541 28.7164 6.71434 28.72C6.18559 28.72 5.66281 28.7425 5.14602 28.7875C5.51187 33.3927 7.32863 37.7632 10.3351 41.2708L18.5859 33.0242Z",
    fill: "#1B51BB",
    fillOpacity: 0.08
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9991 29.3845L23.3657 33.0179C26.7803 36.9856 28.6562 42.0478 28.6518 47.2825C28.6518 47.8098 28.6318 48.3425 28.5949 48.8645C33.2694 48.5354 37.7141 46.7113 41.2722 43.6618L26.9991 29.3845Z",
    fill: "#1B51BB",
    fillOpacity: 0.08
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2839 28.6504C42.0492 28.6548 36.987 26.7789 33.0193 23.3643L29.3859 26.9977L43.6632 41.2708C46.7148 37.7134 48.5411 33.2687 48.8723 28.5934C48.3439 28.6304 47.8155 28.6504 47.2839 28.6504Z",
    fill: "#1B51BB",
    fillOpacity: 0.08
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6124 26.9977L10.3351 12.7246C7.28328 16.2819 5.45694 20.7267 5.12598 25.402C5.65332 25.365 6.18066 25.345 6.70801 25.345C11.9427 25.3406 17.0049 27.2165 20.9727 30.6311L24.6124 26.9977Z",
    fill: "#1B51BB",
    fillOpacity: 0.08
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7261 43.6618C16.2327 46.6676 20.6021 48.4843 25.2062 48.8508C25.2505 48.334 25.273 47.8113 25.2737 47.2825C25.2773 42.9427 23.7536 38.74 20.9695 35.4109L12.7261 43.6618Z",
    fill: "#1B51BB",
    fillOpacity: 0.08
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketballratingIcon);
export default __webpack_public_path__ + "static/media/basketballrating_icon.81043042dacfdc7f3f1863b9b7cb5d64.svg";
export { ForwardRef as ReactComponent };